import t, { PureComponent as e } from "react";
import n from "prop-types";
import r from "signature_pad";
import { debounce as i } from "throttle-debounce";

function o(t, e) {
  return t(e = {
    exports: {}
  }, e.exports), e.exports;
}

var a = o(function (t) {
  function e() {
    return t.exports = e = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }

      return t;
    }, e.apply(this, arguments);
  }

  t.exports = e;
});

var s = function (t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
};

function u(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}

var c = function (t, e, n) {
  return e && u(t.prototype, e), n && u(t, n), t;
};

var f = function (t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
},
    h = o(function (t) {
  function e(n, r) {
    return t.exports = e = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    }, e(n, r);
  }

  t.exports = e;
});

var p = function (t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), e && h(t, e);
},
    l = o(function (t) {
  function e(n) {
    return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? t.exports = e = function (t) {
      return typeof t;
    } : t.exports = e = function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, e(n);
  }

  t.exports = e;
});

var d = function (t, e) {
  return !e || "object" !== l(e) && "function" != typeof e ? f(t) : e;
},
    g = o(function (t) {
  function e(n) {
    return t.exports = e = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    }, e(n);
  }

  t.exports = e;
});

var v = function (t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
};

function y() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}

var _ = function (n) {
  p(h, e);
  var o,
      u = (o = h, function () {
    var t,
        e = g(o);

    if (y()) {
      var n = g(this).constructor;
      t = Reflect.construct(e, arguments, n);
    } else t = e.apply(this, arguments);

    return d(this, t);
  });

  function h(t) {
    var e;
    return s(this, h), (e = u.call(this, t)).state = {
      canvasWidth: 0,
      canvasHeight: 0
    }, e._callResizeHandler = i(e.props.debounceInterval, e.handleResize.bind(f(e))), e;
  }

  return c(h, [{
    key: "componentDidMount",
    value: function () {
      this._canvas && (this.props.width && this.props.height || (this._canvas.style.width = "100%"), this.scaleCanvas(), this.props.width && this.props.height || window.addEventListener("resize", this._callResizeHandler), this._signaturePad = new r(this._canvas, this.props.options));
    }
  }, {
    key: "componentWillUnmount",
    value: function () {
      this.props.width && this.props.height || window.removeEventListener("resize", this._callResizeHandler), this._signaturePad.off();
    }
  }, {
    key: "isEmpty",
    value: function () {
      return this._signaturePad.isEmpty();
    }
  }, {
    key: "clear",
    value: function () {
      this._signaturePad.clear();
    }
  }, {
    key: "fromDataURL",
    value: function (t) {
      this._signaturePad.fromDataURL(t);
    }
  }, {
    key: "toDataURL",
    value: function (t) {
      return this._signaturePad.toDataURL(t);
    }
  }, {
    key: "fromData",
    value: function (t) {
      this._signaturePad.fromData(t);
    }
  }, {
    key: "toData",
    value: function () {
      return this._signaturePad.toData();
    }
  }, {
    key: "off",
    value: function () {
      this._signaturePad.off();
    }
  }, {
    key: "on",
    value: function () {
      this._signaturePad.on();
    }
  }, {
    key: "handleResize",
    value: function () {
      this.scaleCanvas();
    }
  }, {
    key: "scaleCanvas",
    value: function () {
      var t,
          e = Math.max(window.devicePixelRatio || 1, 1),
          n = (this.props.width || this._canvas.offsetWidth) * e,
          r = (this.props.height || this._canvas.offsetHeight) * e,
          i = this.state,
          o = i.canvasWidth,
          a = i.canvasHeight;
      n === o && r === a || (this.props.redrawOnResize && this._signaturePad && (t = this._signaturePad.toDataURL()), this._canvas.width = n, this._canvas.height = r, this.setState({
        canvasWidth: n,
        canvasHeight: r
      }), this._canvas.getContext("2d").scale(e, e), this.props.redrawOnResize && this._signaturePad ? this._signaturePad.fromDataURL(t) : this._signaturePad && this._signaturePad.clear());
    }
  }, {
    key: "render",
    value: function () {
      var e = this,
          n = this.props.canvasProps;
      return t.createElement("canvas", a({
        ref: function (t) {
          return e._canvas = t;
        }
      }, n));
    }
  }, {
    key: "instance",
    get: function () {
      return this._signaturePad;
    }
  }, {
    key: "canvas",
    get: function () {
      return this._canvas;
    }
  }, {
    key: "dotSize",
    set: function (t) {
      this._signaturePad.dotSize = t;
    },
    get: function () {
      return this._signaturePad.dotSize;
    }
  }, {
    key: "minWidth",
    set: function (t) {
      this._signaturePad.minWidth = t;
    },
    get: function () {
      return this._signaturePad.minWidth;
    }
  }, {
    key: "maxWidth",
    set: function (t) {
      this._signaturePad.maxWidth = t;
    },
    get: function () {
      return this._signaturePad.maxWidth;
    }
  }, {
    key: "throttle",
    set: function (t) {
      this._signaturePad.throttle = t;
    },
    get: function () {
      return this._signaturePad.throttle;
    }
  }, {
    key: "backgroundColor",
    set: function (t) {
      this._signaturePad.backgroundColor = t;
    },
    get: function () {
      return this._signaturePad.backgroundColor;
    }
  }, {
    key: "penColor",
    set: function (t) {
      this._signaturePad.penColor = t;
    },
    get: function () {
      return this._signaturePad.penColor;
    }
  }, {
    key: "velocityFilterWeight",
    set: function (t) {
      this._signaturePad.velocityFilterWeight = t;
    },
    get: function () {
      return this._signaturePad.velocityFilterWeight;
    }
  }, {
    key: "onBegin",
    set: function (t) {
      if (!t || "function" != typeof t) throw new Error("Invalid argument passed to onBegin()");
      this._signaturePad.onBegin = t;
    }
  }, {
    key: "onEnd",
    set: function (t) {
      if (!t || "function" != typeof t) throw new Error("Invalid argument passed to onEnd()");
      this._signaturePad.onEnd = t;
    }
  }]), h;
}();

v(_, "displayName", "react-signature-pad-wrapper"), v(_, "propTypes", {
  width: n.number,
  height: n.number,
  options: n.object,
  redrawOnResize: n.bool.isRequired,
  debounceInterval: n.number.isRequired,
  canvasProps: n.object
}), v(_, "defaultProps", {
  redrawOnResize: !1,
  debounceInterval: 150
});
export default _;